module.exports = __webpack_public_path__ + "static/media/img96.718f6340.jpg";